import { INotificationMessage } from "@fl/shared/src/types/messages";
import { NotasServicoListResponse } from "@fl/shared/src/types/models/governo/nota_servico";
import { DespesasToRelease } from "@fl/shared/src/types/models/superlogica/despesas";
import moment from "moment";
import { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import TableData from "../../../../../components/tables";
import ApiNFSe from "../../../../../services/suporte/auth/notas/servicos";
import despesaValidation from "../../../../../utils/lancamentoDespesa/validacao";
import DefaultBasePage from "../../../../default/base";

export enum TipoPagamento {
  NOTA_FISCAL = 1,
  IMPOSTO = 2,
  FATURA = 3,
  RECIBO = 4,
  CUPOM_FISCAL = 5,
  OUTROS = 6,
  FOLHA_PAGAMENTO = 7,
}

const LancamentosNotasNFSEPrivatePage = () => {
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState<INotificationMessage[]>([]);
  const [notas, setNotas] = useState<NotasServicoListResponse | null>(null);
  const [despesas, setDespesas] = useState<DespesasToRelease[]>([]);

  useEffect(() => {
    const loadData = async () => {
      const result = await new ApiNFSe().listToRelease();
      if (result.success) setNotas(result.data);
    };

    loadData();
  }, []);

  useEffect(() => {
    if (notas) fillDespesas(notas);
  }, [notas]);

  useEffect(() => {}, [despesas]);

  const fillDespesas = (notasRaw: NotasServicoListResponse) => {
    const newDespesas: DespesasToRelease[] = notasRaw.notas.map(
      (item, index) => {
        var lancamento: DespesasToRelease = {
          index,
          selecionado: true,
          validacao: {
            status: "SUCESSO",
            mensagens: [],
          },
          despesa: {
            id_condominio_cond: item.id_tomador,
            id_contato_con: item.prestador && item.prestador.id_contato_con,
            st_nome_con: item.prestador && item.prestador.st_nome_con,
            dt_despesa_des: item.data_nfe,
            id_tipo_doc: TipoPagamento.NOTA_FISCAL,
            st_documento_des: item.numero_nfe,
            st_serienota_des: item.serie_rps ?? undefined,
            //ST_NOMERECEBEDOR_FAV - buscar despesa relacionado no DB
            //ID_FAVORECIDO_CON - buscar despesa relacionado no DB
            //DT_VENCIMENTOPRIMEIRAPARCELA - usar CHATGPT para analisar descrição da NFE
            //ID_FORMA_PAG - usar CHATGPT para analisar descrição da NFE
            //DADOS_PAGAMENTOS - VERIFICAR
            //ID_FAVORECIDO_FAV - VERIFICAR
            //ID_CONTABANCO_CB - get Bancos do condomínio e trazer como default [0]
          },
          apropriacoes: [],
          retencoes: [],
          condominio: item.tomador,
          fornecedor: item.prestador,
        };

        lancamento = despesaValidation(lancamento);
        return lancamento;
      }
    );

    setDespesas(newDespesas);
  };

  console.log(despesas);

  return (
    <DefaultBasePage
      title="Lançamento de Notas de Serviços (NFSe)"
      subtitle={
        notas && notas.controle
          ? `Último período apurado: ${moment(notas.controle.data_inicio_consulta).format("DD/MM/YY")} a ${moment(notas.controle.data_fim_consulta).format("DD/MM/YY")} - Total de notas: ${notas.controle.quantidade_total_notas}`
          : ""
      }
      filterComp={false}
      loading={loading}
      message={messages}
    >
      <div className="text-justify">
        <Accordion defaultActiveKey={["0"]} alwaysOpen flush>
          <Accordion.Item eventKey="0">
            <Accordion.Header>Fornecedores</Accordion.Header>
            <Accordion.Body>
              <div className="text-justify">
                <TableData columns={[]} data={[]} />
              </div>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>Notas</Accordion.Header>
            <Accordion.Body>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur. Excepteur sint occaecat cupidatat non proident,
              sunt in culpa qui officia deserunt mollit anim id est laborum.
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </DefaultBasePage>
  );
};
export default LancamentosNotasNFSEPrivatePage;
